import React from "react";
import { useNavigate } from "react-router-dom";

import setUpTeamsImg from "../../assets/image/setUpTeams.png";

const SetUpTeamCard = ({ user }) => {
  const navigate = useNavigate();

  const handleSetUpTeam = () => {
    if (user?.role === "Expert") {
      navigate("/expert/teams");
    } else if (user?.role === "Customer") {
      navigate("/user/teams");
    }
  };

  return (
    <div>
      {" "}
      <div className="bg-[#F15D180A] h-[263px]  rounded-[24px] p-6 px-12 flex flex-col md:flex-row justify-between items-center  shadow-sm my-4">
        <div className="text-left mb-6 md:mb-0">
          <h1 className="text-[36px] nunito-medium text-[#404040] mb-2">
            Set up your Team
          </h1>
          <p className="text-[#696969] text-[16px] nunito-regular mb-4">
            Create and manage your team with ease using Supporty.io
            <br />
            Stay organized and boost productivity!
          </p>{" "}
          <button
            onClick={handleSetUpTeam}
            className="w-[162px] h-[48px] bg-[#F15D18] text-[14px] nunito-bold hover:bg-orange-600 text-white font-medium py-3 px-6 rounded-[8px] transition-colors"
          >
            Set up your Team
          </button>
        </div>

        <div className="relative h-[183px] w-[346px]">
          {/* Illustration of three people with laptops */}
          <img
            src={setUpTeamsImg}
            alt="Set up your team"
            className="absolute inset-0 w-full h-full object-cover rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default SetUpTeamCard;
